export default function ImageUploadField({
  label = 'Images',
  multiple = false,
  existingUrls = [],
  onExistingChange,
  files = [],
  onFilesChange,
  maxFiles = 10,
}) {
  const handleFileChange = (event) => {
    const selected = Array.from(event.target.files || []);
    if (!selected.length) return;

    if (multiple) {
      const combined = [...files, ...selected].slice(0, maxFiles);
      onFilesChange(combined);
    } else {
      onFilesChange(selected.slice(0, 1));
    }

    event.target.value = '';
  };

  const removeExisting = (index) => {
    onExistingChange(existingUrls.filter((_, i) => i !== index));
  };

  const removeNew = (index) => {
    onFilesChange(files.filter((_, i) => i !== index));
  };

  const totalCount = existingUrls.length + files.length;
  const canAddMore = multiple ? totalCount < maxFiles : totalCount < 1;

  return (
    <div className="form-group full">
      <label>{label}</label>

      {(existingUrls.length > 0 || files.length > 0) && (
        <div className="image-upload-grid">
          {existingUrls.map((url, index) => (
            <div key={`existing-${url}-${index}`} className="image-upload-preview">
              <img src={url} alt="" />
              <button
                type="button"
                className="image-upload-remove"
                onClick={() => removeExisting(index)}
                aria-label="Remove image"
              >
                ×
              </button>
            </div>
          ))}
          {files.map((file, index) => (
            <div key={`new-${file.name}-${index}`} className="image-upload-preview">
              <img src={URL.createObjectURL(file)} alt="" />
              <button
                type="button"
                className="image-upload-remove"
                onClick={() => removeNew(index)}
                aria-label="Remove selected image"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {canAddMore && (
        <input
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/webp,image/gif"
          multiple={multiple}
          onChange={handleFileChange}
          className="input"
        />
      )}

      <p className="field-hint">
        Upload JPEG, PNG, WEBP, or GIF up to 5MB
        {multiple ? ` (max ${maxFiles} images)` : ''}
      </p>
    </div>
  );
}
